import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class LotacaoService {
    private subject = new Subject<any>();

    setLotacao(lotacao: string) {
        this.subject.next({ text: lotacao });
    }

    clearLotacao() {
        this.subject.next();
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}


// WEBPACK FOOTER //
// ./src/app/util/obsevable-lotacao-user.ts